import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";

import {
  getFirestoreDocument,
  updateFirestoreDocument,
  firebaseLogin,
  firebaseLogout,
  isFirebaseAuthenticated,
} from "../../firebase/firebase";

import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class AppVersionConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ==========================================
      // GENERAL
      // ==========================================

      isLoaded: false,

      // ==========================================
      // FIREBASE AUTHENTICATION
      // ==========================================

      firebaseAuthenticated: false,

      firebaseAuthenticating: true,

      firebaseEmail:
        "jccreationsbusiness@gmail.com",

      // Password is NOT displayed in this screen.
      // firebaseLogin() should handle the credentials.
      firebasePassword: "",

      // ==========================================
      // APP CONFIGURATION
      // ==========================================

      android_version_code: "",

      android_version_name: "",

      // true = Active
      // false = Inactive
      maintenance_mode: false,
    };
  }

  componentDidMount() {
    this.initializeAuthentication();
  }

  // =====================================================
  // AUTOMATIC FIREBASE AUTHENTICATION
  // =====================================================

  initializeAuthentication = async () => {
    this.setState({
      firebaseAuthenticating: true,
      firebaseAuthenticated: false,
    });

    try {
      // ================================================
      // CHECK EXISTING AUTHENTICATION
      // ================================================

      if (isFirebaseAuthenticated()) {
        this.setState({
          firebaseAuthenticated: true,
          firebaseAuthenticating: false,
        });

        await this.loadConfig();

        return;
      }

      // ================================================
      // AUTOMATIC FIREBASE LOGIN
      // ================================================

      await firebaseLogin(
        this.state.firebaseEmail,
        this.state.firebasePassword
      );

      // ================================================
      // AUTHENTICATION SUCCESS
      // ================================================

      this.setState({
        firebaseAuthenticated: true,
        firebaseAuthenticating: false,
      });

      await this.loadConfig();

    } catch (error) {
      console.error(
        "Automatic Firebase authentication error:",
        error
      );

      firebaseLogout();

      this.setState({
        firebaseAuthenticated: false,
        firebaseAuthenticating: false,
        isLoaded: false,
      });

      NotificationManager.error(
        "Firebase authentication failed. Configuration is locked.",
        "Authentication Error"
      );
    }
  };

  // =====================================================
  // LOAD CONFIG
  // =====================================================

  loadConfig = async () => {
    this.setState({
      isLoaded: true,
    });

    try {
      const data =
        await getFirestoreDocument(
          "config",
          "appVersion"
        );

      const fields =
        data.fields || {};

      this.setState({
        android_version_code:
          fields.android_version_code &&
          fields.android_version_code.integerValue
            ? fields.android_version_code.integerValue
            : "",

        android_version_name:
          fields.android_version_name &&
          fields.android_version_name.doubleValue !==
            undefined
            ? String(
                fields.android_version_name.doubleValue
              )
            : fields.android_version_name &&
              fields.android_version_name.integerValue
              ? String(
                  fields.android_version_name.integerValue
                )
              : "",

        maintenance_mode:
          fields.maintenance_mode &&
          fields.maintenance_mode.booleanValue === true,

        isLoaded: false,
      });

    } catch (error) {
      console.error(
        "Error loading config:",
        error
      );

      this.setState({
        isLoaded: false,
      });

      NotificationManager.error(
        "Unable to load app configuration",
        "Error"
      );
    }
  };

  // =====================================================
  // HANDLE CHANGE
  // =====================================================

  handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    this.setState({
      [name]:
        name === "maintenance_mode"
          ? value === "true"
          : value,
    });
  };

  // =====================================================
  // BACK
  // =====================================================

  handleBack = () => {
    this.props.history.goBack();
  };

  // =====================================================
  // UPDATE CONFIG
  // =====================================================

  handleSubmit = async () => {
    // ================================================
    // SECURITY CHECK
    // ================================================

    if (!isFirebaseAuthenticated()) {
      this.setState({
        firebaseAuthenticated: false,
      });

      NotificationManager.error(
        "Authentication is required before updating.",
        "Authentication Required"
      );

      return;
    }

    const {
      android_version_code,
      android_version_name,
      maintenance_mode,
    } = this.state;

    // ================================================
    // VALIDATE VERSION CODE
    // ================================================

    if (
      !android_version_code ||
      Number.isNaN(
        Number(android_version_code)
      ) ||
      Number(android_version_code) <= 0
    ) {
      NotificationManager.error(
        "Valid Android version code is required",
        "Input Error"
      );

      return;
    }

    // ================================================
    // VALIDATE VERSION NAME
    // ================================================

    if (
      !android_version_name ||
      Number.isNaN(
        Number(android_version_name)
      ) ||
      Number(android_version_name) <= 0
    ) {
      NotificationManager.error(
        "Valid Android version name is required",
        "Input Error"
      );

      return;
    }

    this.setState({
      isLoaded: true,
    });

    try {
      // ================================================
      // UPDATE FIRESTORE
      // ================================================
      //
      // gateway and any other existing fields are
      // intentionally NOT touched.
      //
      // ================================================

      await updateFirestoreDocument(
        "config",
        "appVersion",
        {
          android_version_code: {
            integerValue: String(
              Number(
                android_version_code
              )
            ),
          },

          android_version_name: {
            doubleValue:
              Number(
                android_version_name
              ),
          },

          maintenance_mode: {
            booleanValue:
              maintenance_mode === true,
          },
        }
      );

      this.setState({
        isLoaded: false,
      });

      NotificationManager.success(
        "App configuration updated successfully",
        "Configuration Updated"
      );

      await this.loadConfig();

    } catch (error) {
      console.error(
        "Error updating config:",
        error
      );

      this.setState({
        isLoaded: false,
      });

      // ================================================
      // FIRESTORE PERMISSION ERROR
      // ================================================

      if (
        (error.message &&
          error.message.includes(
            "PERMISSION_DENIED"
          )) ||
        (error.message &&
          error.message.includes(
            "permission"
          ))
      ) {
        firebaseLogout();

        this.setState({
          firebaseAuthenticated: false,
        });

        NotificationManager.error(
          "Authentication expired or you do not have permission to update this configuration.",
          "Permission Denied"
        );

        return;
      }

      NotificationManager.error(
        error &&
        error.message
          ? error.message
          : "Unable to update app configuration",
        "Error"
      );
    }
  };

  // =====================================================
  // RENDER
  // =====================================================

  render() {
    const {
      isLoaded,
      android_version_code,
      android_version_name,
      maintenance_mode,
      firebaseAuthenticated,
      firebaseAuthenticating,
    } = this.state;

    const configurationEnabled =
      firebaseAuthenticated &&
      !firebaseAuthenticating;

    return (
      <div className="container-fluid">

        {/* ==========================================
            HEADER
        ========================================== */}

        <div className="row">

          <div className="col-lg-5 col-md-9">

            <h2 className="mt-30 page-title">
              App Configuration
            </h2>

          </div>

          <div className="col-lg-5 col-md-3 back-btn">

            <Button
              variant="contained"
              onClick={
                this.handleBack
              }
            >
              <i className="fas fa-arrow-left" />
              {" "}
              Back
            </Button>

          </div>

        </div>

        {/* ==========================================
            BREADCRUMB
        ========================================== */}

        <ol className="breadcrumb mb-30">

          <li className="breadcrumb-item">
            Dashboard
          </li>

          <li className="breadcrumb-item">
            Config
          </li>

          <li className="breadcrumb-item active">
            App Configuration
          </li>

        </ol>

        {/* ==========================================
            FORM
        ========================================== */}

        <Paper
          className="user-management"
          style={{
            padding: "1.5rem",
            marginBottom: "50px",
          }}
        >

          {isLoaded && (
            <Loader />
          )}

          {/* =====================================================
              FIREBASE AUTHENTICATION STATUS
          ===================================================== */}

          <div
            style={{
              marginBottom: "30px",
              padding: "20px",
              borderRadius: "10px",

              border:
                configurationEnabled
                  ? "1px solid #28a745"
                  : "1px solid #dee2e6",

              background:
                configurationEnabled
                  ? "#f0fff4"
                  : "#f8f9fa",
            }}
          >

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >

              <div>

                <h5
                  style={{
                    margin: 0,
                    fontWeight: "600",
                  }}
                >
                  Configuration Authentication
                </h5>

                <small className="text-muted">

                  {firebaseAuthenticating
                    ? "Authenticating securely. Please wait..."
                    : configurationEnabled
                      ? "Authentication verified. You can now update the App configuration."
                      : "Authentication failed. Configuration is locked."}

                </small>

              </div>

              {/* ======================================
                  AUTHENTICATING
              ====================================== */}

              {firebaseAuthenticating && (

                <span
                  style={{
                    background: "#ffc107",
                    color: "#212529",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >

                  <i className="fas fa-spinner fa-spin mr-1" />

                  AUTHENTICATING

                </span>

              )}

              {/* ======================================
                  AUTHENTICATED
              ====================================== */}

              {!firebaseAuthenticating &&
                firebaseAuthenticated && (

                  <span
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >

                    <i className="fas fa-check-circle mr-1" />

                    AUTHENTICATED

                  </span>

                )}

              {/* ======================================
                  FAILED
              ====================================== */}

              {!firebaseAuthenticating &&
                !firebaseAuthenticated && (

                  <span
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >

                    <i className="fas fa-times-circle mr-1" />

                    NOT AUTHENTICATED

                  </span>

                )}

            </div>

          </div>

          {/* =====================================================
              CONFIGURATION
          ===================================================== */}

          <div
            style={{
              opacity:
                configurationEnabled
                  ? 1
                  : 0.55,

              transition:
                "opacity 0.2s ease",
            }}
          >

            <div className="row">

              {/* ======================================
                  VERSION CODE
              ====================================== */}

              <div className="col-md-6 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Android Version Code
                </label>

                <input
                  type="number"
                  className="form-control"
                  name="android_version_code"
                  value={
                    android_version_code
                  }
                  onChange={
                    this.handleChange
                  }
                  placeholder="Example: 49"
                  min="1"
                  disabled={
                    !configurationEnabled
                  }
                />

                <small className="text-muted">
                  Example: 49
                </small>

              </div>

              {/* ======================================
                  VERSION NAME
              ====================================== */}

              <div className="col-md-6 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Android Version Name
                </label>

                <input
                  type="number"
                  step="0.0001"
                  className="form-control"
                  name="android_version_name"
                  value={
                    android_version_name
                  }
                  onChange={
                    this.handleChange
                  }
                  placeholder="Example: 1.0047"
                  min="0"
                  disabled={
                    !configurationEnabled
                  }
                />

                <small className="text-muted">
                  Example: 1.0047
                </small>

              </div>

              {/* ======================================
                  MAINTENANCE MODE
              ====================================== */}

              <div className="col-md-6 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Maintenance Mode
                </label>

                <select
                  className="form-control"
                  name="maintenance_mode"
                  value={String(
                    maintenance_mode
                  )}
                  onChange={
                    this.handleChange
                  }
                  disabled={
                    !configurationEnabled
                  }
                >

                  <option value="true">
                    Active
                  </option>

                  <option value="false">
                    Inactive
                  </option>

                </select>

                <small className="text-muted">
                  Active = Maintenance Mode ON
                  {" | "}
                  Inactive = Maintenance Mode OFF
                </small>

              </div>

            </div>

            {/* ==========================================
                UPDATE
            ========================================== */}

            <button
              type="button"
              className="btn btn-primary col-sm-3 mt-3 py-2"
              onClick={
                this.handleSubmit
              }
              disabled={
                isLoaded ||
                !configurationEnabled
              }
            >

              <i className="fas fa-save mr-2" />

              Update Configuration

            </button>

          </div>

        </Paper>

        {/* ==========================================
            BOTTOM SPACING
        ========================================== */}

        <div
          style={{
            height: "60px",
          }}
        />

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/config/view/index.js